import newColors from "@/styles/newColors"
import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(({
	titleText: {
		fontSize: "24px",
		fontWeight: 600,
		color: newColors.grey[600]
	}
}))

export default useStyles
